export const protectEmailInState = (state: unknown): state is { email: string } =>
  !!state && 'email' in (state as { email: string });
